/*
 * Copyright (c) Arbeidskracht Groep B.V. - all rights reserved
 */

import {StyleSheet} from 'aphrodite/no-important';

const styles = StyleSheet.create({
	linkButton: {
		':active': {
			outline: 'none'
		},
		':active:focus': {
			outline: 'none'
		},
		':focus': {
			outline: 'none'
		},
		border: 'none',
		margin: 0,
		padding: 0,
		verticalAlign: 'inherit'
	}
});

export default styles;
